import { Link } from 'react-router-dom';
import { usePopup } from '@/lib/PopupContext';
import { openChat } from '@/lib/chat';

export default function LPHeader() {
  const { openPopup } = usePopup();

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-zinc-200"
      data-testid="lp-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        <Link to="/lp" className="flex items-center gap-1" data-testid="lp-logo">
          <img src="/assets/img/brand/logo-dark.png" alt="AmericanTrademark Firm" className="h-7 sm:h-9 w-auto" />
        </Link>
        <div className="flex items-center gap-3">
          <button
            onClick={() => openPopup()}
            className="bg-[#002FA7] text-white hover:bg-[#002480] transition-colors px-3 py-2 sm:px-5 sm:py-2.5 font-bold text-[9px] sm:text-xs tracking-wide sm:tracking-widest uppercase border border-transparent whitespace-nowrap"
            data-testid="lp-register-btn"
          >
            Register My Trademark
          </button>
          <button
            onClick={openChat}
            className="hidden sm:block bg-transparent text-[#09090B] hover:bg-[#F4F4F5] transition-colors px-5 py-2.5 font-bold text-xs tracking-widest uppercase border border-[#09090B]"
            data-testid="lp-chat-btn"
          >
            Chat Now
          </button>
        </div>
      </div>
    </header>
  );
}
